/** Hält die vom Grid gemeldete Zeilenzahl für die Kopfzeile bereit (REQ-21 §3). */

import { useMemo, useState, type ReactNode } from 'react';

import { GridRowCountContext, type GridRowCountValue } from './gridRowCountContext';

export interface GridRowCountProviderProps {
  children: ReactNode;
}

export function GridRowCountProvider(props: GridRowCountProviderProps) {
  const [count, setCount] = useState<number | null>(null);
  const value = useMemo<GridRowCountValue>(() => ({ count, setCount }), [count]);

  return (
    <GridRowCountContext.Provider value={value}>{props.children}</GridRowCountContext.Provider>
  );
}

export default GridRowCountProvider;
